<template>
  <div>
    <b-form-group id="input-group-14" label="Motivo" label-for="input-14">
      <b-form-select
        id="input-14"
        v-model="motiveSelected"
        :options="motivesAprobation"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <b-form-group
      id="input-group-17"
      label="Observaciones"
      label-for="input-17"
    >
      <b-form-input
        id="input-17"
        v-model="form.observation"
        placeholder="Ingrese aquí sus observaciones"
        required
      ></b-form-input>
    </b-form-group>
    <b-row>
      <b-col cols="12" class="text-center">
        <b-button @click="aprobarOS" class="btn-orange">
          <font-awesome-icon icon="calendar-day" /> Aprobar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import {mapState} from 'vuex'
export default {
  name: "AprobarOs",
  props: ["detailId"],
  data() {
    return {
      motivesAprobation: [],
      motiveSelected: null,
      form: { observation: "" },
      valuesResponseAprobar: { show: true, message: "", hasError: false },
    };
  },
  created() {
    this.listMotiveAprobacion();
  },
  computed:{
    ...mapState("module", ["username"]),
  },
  methods: {
    async aprobarOS() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/approvals",
          {
            motive: this.motiveSelected,
            childId: this.detailId,
            observation: this.form.observation,
            user:this.username
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        this.valuesResponseAprobar.message = "Aprobación exitosa";
       
      } catch (error) {
        console.log(error);
        this.valuesResponseAprobar.hasError = true;
        this.valuesResponseAprobar.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-aprobar");
        this.$emit("setResponse", this.valuesResponseAprobar);
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listMotiveAprobacion() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/motives?limit=20&page=1&pagination=true&type=APPROVAL_CREATION"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.motivesAprobation = data;
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
</style>
